import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'TabButton',
  props: {
    selected: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["rounded-xs py-1 px-2 lg:px-6 mb-2", { 'bg-green': props.selected, 'bg-green-3': !props.selected }])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})